import { useRef, useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

// Free profile evaluation — a Google Form in the DAAS Global account. Answers go straight into the DAAS ERP as leads.
// The form's confirmation message links to the optional document & CV upload form (Google sign-in needed for uploads).
const EVALUATION_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScj01PDH2KETQFDpX_ceJYh5deRCUAuXpwm8kyImCeJLpOWUg/viewform';

const StudentEvaluationForm = ({ isOpen, onClose }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-modal-overlay"
      onClick={(e) => { if (e.target === overlayRef.current) onClose(); }}
      data-testid="student-form-overlay"
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        className="relative bg-white w-full max-w-2xl h-[90vh] flex flex-col animate-modal-slide-up"
        data-testid="student-form-modal"
      >
        {/* Header */}
        <div className="bg-white z-10 px-8 pt-8 pb-4 border-b border-[var(--border)]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[var(--secondary)] text-xs font-bold uppercase tracking-[0.2em] mb-1">Free Evaluation</p>
              <h2 className="text-2xl font-bold text-[var(--primary)] tracking-tight">Student Profile Evaluation</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-[var(--background)] transition-colors" data-testid="student-form-close">
              <X size={20} />
            </button>
          </div>
          <a
            href={EVALUATION_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-xs text-[var(--text-secondary)] hover:text-[var(--secondary)] mt-2"
          >
            Form not loading? Open it in a new tab <ExternalLink size={12} />
          </a>
        </div>

        <iframe
          src={`${EVALUATION_FORM_URL}?embedded=true`}
          title="Free Student Profile Evaluation form"
          className="flex-1 w-full border-0"
          data-testid="student-evaluation-form"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
};

export default StudentEvaluationForm;
